import type { AskResponse, MeetingDebriefRowDto } from '../../types/lobbyDay'

export interface RosterEntry {
  contactId: string
  fullName: string
  district: string | null
  legislatorName: string
  askTitle: string | null
}

export function groupRosterByOutcome(
  rows: MeetingDebriefRowDto[], askId: string | null, response: AskResponse,
): RosterEntry[] {
  return rows
    .filter((row) => row.askId === askId && row.askResponse === response)
    .flatMap((row) =>
      row.attendees.map((a) => ({
        contactId: a.contactId,
        fullName: a.fullName,
        district: a.district,
        legislatorName: row.legislatorName,
        askTitle: row.askTitle,
      })),
    )
}
